<div class="w-full p-3 flex flex-wrap content-start rounded-lg scroll-dialog">
  @if(!loading){
  <article infiniteScroll [infiniteScrollDistance]="2" [scrollWindow]="false" [infiniteScrollThrottle]="50"
    (scrolled)="loadMore()"
    class="w-full max-md:max-h-[65vh] md:max-h-[500px] hide-scroll overflow-y-auto flex content-start flex-wrap">
    <!-- ? user List -->
    <ng-container *ngFor="let user of dataUser; let i = index">
      <div class="w-full flex flex-wrap items-center mb-2 justify-between">
        <!-- ? Image & UserName -->
        <div class="w-8/12 lg:9/12 flex items-center">
          <!-- ? Actor Image -->
          <ng-container *ngTemplateOutlet="
                imageTemplate;
                context: {
                  alt: user?.fullName,
                  hasPhoto: user?.hasPhoto,
                  routeId: (user?.type === userTypeEnum.Author || user?.type === userTypeEnum.Publisher) ? user.id : user?.userName,
                  id: user.id,
                  link: routes.profile,
                  imageType:
                    user?.type === userTypeEnum.Publisher
                      ? imageType.publisherAvatar
                      : user?.type === userTypeEnum.Author
                      ? imageType.authorAvatar
                      : imageType.userAvatar
                }
              ">
          </ng-container>

          <!-- ? Fullname -->
          <a class="cursor-pointer px-2 text-base text-gray-900 line-clamp-1"
            [routerLink]="[routes.profile, user?.userName]" matDialogClose *ngIf="user.type == 1" (click)="close()">
            {{ user.fullName }}
          </a>

          <a class="cursor-pointer px-2 text-base text-gray-900 line-clamp-1" [routerLink]="[routes.profile, user.id]"
            matDialogClose *ngIf="user.type == 4" (click)="close()">
            {{ user.fullName }}
          </a>
        </div>

        <!-- ? Follow State Button -->
        <div class="w-4/12 max-w-32 flex items-center justify-center">
          <app-follow-btn class="w-full" [customHeight]="'min-h-8'" [user]="user | followUserData" (onProfile)="close()"
            (Follow)="FollowClicked($event)"></app-follow-btn>
        </div>
      </div>
    </ng-container>

  </article>

  <!-- ? load More Button -->
  <!-- @if(loadingMore){
  <div class="w-full sticky bottom-0 flex justify-center">
    <button class="disabled:!bg-transparent" [appButtonLoader]="loadingMore">
    </button>
  </div>
  }@else {
  <span class="w-full sticky bottom-0 h-10"></span>
  } -->

  }@else{
  <div class="w-full mt-2 flex flex-wrap">
    <div class="w-full mb-2 flex flex-wrap items-center" *ngFor="let i of [1, 2, 3]">
      <ngx-skeleton-loader [appearance]="'circle'" [theme]="{ height: '48px', width: '48px' }">
      </ngx-skeleton-loader>
      <div class="col">
        <ngx-skeleton-loader class="flex" [theme]="{ height: '16px', width: '140px', display: 'block' }">
        </ngx-skeleton-loader>
      </div>
    </div>
  </div>
  }
</div>


<!-- ? Actor Image -->
<ng-template #imageTemplate let-link="link" let-imageType="imageType" let-id="id" let-alt="alt" let-hasPhoto="hasPhoto"
  let-routeId="routeId">
  <a class="cursor-pointer" [routerLink]="[link, routeId]" (click)="close()">
    <img loading="lazy" class="avatar-md" width="48" height="48" [src]="id | image : imageType : hasPhoto"
      onerror="this.src='https://cloud.behkhaan.ir/assets/images/default/default_avatar.svg'" [alt]="alt" />
  </a>
</ng-template>